import { render } from "./h5_login.vue?vue&type=template&id=adb96dc4&scoped=true"
import script from "./h5_login.vue?vue&type=script&lang=js"
export * from "./h5_login.vue?vue&type=script&lang=js"

import "./h5_login.vue?vue&type=style&index=0&id=adb96dc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb96dc4"]])

export default __exports__